"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getDefaultValue = exports.getComponentType = exports.setNodeAtTop = exports.addZero = exports.genList = void 0;

var _spauiUtils = require("@tencent/spaui-utils");

/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2019, a Tencent company. All rights reserved.
 */
// 生成时间列表
var genList = function genList() {
  var maxNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;
  var result = [];
  var i = 0;

  for (; i < maxNumber; i++) {
    result.push(i);
  }

  return result;
}; // 添加0


exports.genList = genList;

var addZero = function addZero(item) {
  var result = parseInt(item, 10) || 0;

  if (result < 10) {
    result = "0".concat(result);
  } else {
    result = "".concat(result);
  }

  return result;
}; // 子元素默认设置在顶部


exports.addZero = addZero;

var setNodeAtTop = function setNodeAtTop() {
  var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var parentNode = null;

  if (node) {
    parentNode = node.parentNode || null;

    if (parentNode) {
      parentNode.scrollTop = node.offsetTop;
    }
  }
}; // 获取组件的蕾西


exports.setNodeAtTop = setNodeAtTop;

var getComponentType = function getComponentType() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$config = props.config,
      config = _props$config === void 0 ? {} : _props$config,
      timeList = props.timeList;
  var _config$hour = config.hour,
      propsHour = _config$hour === void 0 ? false : _config$hour,
      _config$minute = config.minute,
      propsMinute = _config$minute === void 0 ? false : _config$minute,
      _config$second = config.second,
      propsSecond = _config$second === void 0 ? false : _config$second;
  var result = {
    onlyCustomTime: false,
    onlyHour: false,
    onlyHourAndMinute: false,
    hourAndMinuteAndSecond: false
  };

  if (!(0, _spauiUtils.isUndefined)(timeList)) {
    result.onlyCustomTime = true;
  } else if (propsHour && !propsMinute && !propsSecond) {
    result.onlyHour = true;
  } else if (propsHour && propsMinute && !propsSecond) {
    result.onlyHourAndMinute = true;
  } else if (propsHour && propsMinute && propsSecond) {
    result.hourAndMinuteAndSecond = true;
  }

  return result;
}; // 获取默认的时间数据


exports.getComponentType = getComponentType;

var getDefaultValue = function getDefaultValue(value) {
  var valueList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return value || valueList[0] || '00';
};

exports.getDefaultValue = getDefaultValue;
var _default = {
  genList: genList,
  addZero: addZero,
  setNodeAtTop: setNodeAtTop,
  getComponentType: getComponentType,
  getDefaultValue: getDefaultValue
};
exports["default"] = _default;